import { ApiProvider } from '@chartai/api-client';

import { Toaster } from 'sonner';

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ApiProvider>
      {children}
      <Toaster position="top-right" richColors />
    </ApiProvider>
  );
}
